/**
 * Builds the value a combobox shows for its selection: the first label alone, or
 * "First +N more" when several are picked. `moreLabel` is the translated word for "more".
 */
export function buildSelectionLabel(firstLabel: string | undefined, extraCount: number, moreLabel: string) {
  if (!firstLabel) return undefined
  return extraCount <= 0 ? firstLabel : `${firstLabel} +${extraCount} ${moreLabel}`
}
